module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "only-print"
  }, [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCalendarId),
      expression: "selectedCalendarId"
    }],
    staticClass: "no-desktop no-print",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCalendarId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.nativeSelect]
    }
  }, _vm._l((_vm.sortedCalendars), function(calendar) {
    return _c('option', {
      domProps: {
        "value": calendar.id
      }
    }, [_vm._v(_vm._s(calendar.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-container no-mobile no-print",
    class: {
      'd-container--active': _vm.isDropDown
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.setDropdownFromClick),
      expression: "setDropdownFromClick"
    }],
    ref: "d_parent",
    staticClass: "d-select__selected",
    on: {
      "click": _vm.setDropdown
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.isSelectLoading) ? _c('div', {
    staticClass: "d-spinner"
  }) : _c('svg', {
    staticClass: "tw-icon tw-icon-cheveron-selection",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "secondary",
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
    }
  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
    ref: "d_child",
    staticClass: "d-select__dropdown",
    class: {
      'd-dropdown--animate': _vm.isPopperReady,
      'd-dropdown--show': _vm.isPopperDone
    }
  }, [_c('div', {
    ref: "ref_d_select_input_container",
    staticClass: "d-select-input",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "icon-search5"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "inputsearch",
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    ref: "ref_d_select_calendar_dropdown",
    staticClass: "d-select__dropdown__container"
  }, [_vm._l((_vm.calendarQuery), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "d-list-item",
      class: [{
          'd-list-item--highlighted': _vm.getIsTheKeyboardSelected(calendar)
        },
        {
          'd-list-item--selected': calendar.v_selected
        }
      ],
      on: {
        "click": function($event) {
          return _vm.selectCalendar(calendar.id)
        },
        "mouseenter": function($event) {
          return _vm.setTheKeyboardSelected(calendar)
        },
        "mousemove": _vm.onMouseMove
      }
    }, [_vm._v("\n          " + _vm._s(calendar.name) + " "), _c('span', {
      staticClass: "icon-checkmark-circle"
    })])
  }), _vm._v(" "), (_vm.isSchoolCalendarsLoading) ? _c('li', {
    staticClass: "d-select__dropdown__spinner-container"
  }, [_c('div', {
    staticClass: "d-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.calendarQuery.length === 0 && !_vm.isSchoolCalendarsLoading) ? _c('li', {
    staticClass: "d-list-item text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.no_calendars_found')) + "\n        ")]) : _vm._e()], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-153776aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarSelect.vue
// module id = 1774
// module chunks = 1